/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useContext } from 'preact/hooks';
import { ReorderableContext } from './ReorderableContext';

/**
 * Utility hook for consuming the ReorderableContext
 *
 * @returns The value of ReorderableContext provider
 */
function useReorderableContext() {
  return useContext(ReorderableContext);
}

export { useReorderableContext };
